import styled, { css } from 'styled-components';
import { colourPalette } from 'styles/styles';

export const LoginFormPasswordStyle = {
  InputContainer: styled.div<{ $showPasswordError: boolean }>`
    position: relative;
    ${({ $showPasswordError }) =>
      $showPasswordError &&
      css`
        padding-bottom: 32px;
        .form-field-error-message {
          display: none !important;
        }
      `}
  `,
  CustomError: styled.div`
    position: absolute;
    background: ${colourPalette.neutral0};
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
  `,
};
